import styled from 'styled-components';
import {config} from 'react-awesome-styled-grid';

export const MoreProductsStyle = styled.div`
  width: 98%;
  margin: 0 auto;
  .wrap__cards {
    max-height: 500px;
    display: flex;
    flex-basis: 50%;
    flex-wrap: nowrap;
    justify-content: space-evenly;
    align-items: center;
    ${props => config(props).media['sm']`
      flex-basis: 15%;
    `}
    ${props => config(props).media['md']`
      flex-basis: 15%;
    `}
  }
  h3 {
    margin-bottom: 30px;
    padding-top: 20px;
    padding-left: 20px;
    display: flex;
    justify-content: space-between;
    ${props => config(props).media['md']`
      padding-top: 0px;
      padding-left: 8px;
    `}
  }
  .styles__StyledButtonProduct-iZSIYH {
    display: none;
    ${props => config(props).media['md']`
      display: initial;
    `}
  }
  .buttonMobile {
    width: 320px;
    height: 30px;
    background-color: ${({theme}) => theme.colors.primary2};
    padding: 0;
    border: none;
    border-radius: 6px;
    margin-top: 20px;
    margin-right: 10px;
    margin-bottom: 20px;
    outline: none;
    color: white;
    cursor: pointer;
    p {
      color: white;
      font-weight: 600;
      font-size: 13px;
    }

    &:hover {
      background-color: ${({theme}) => theme.colors.primary3};

      p {
        color: white;
      }
    }

    &:active {
      outline: none;
      background-color: #c29f5e;
      p {
        color: white;
      }
    }
  }
  .skeletonMoreProductStyle {
    width: 150px;
    height: 170px;
    border-radius: 20px;
    margin-left: 60px;
    margin-top: 30px;
    align-items: center;
    ${props => config(props).media['md']`
       width: 307px;
    height: 307px;
    margin-left: 30px;
    margin-top: 30px;
    `}
  }
  .empty-state {
    width: 20%;
    margin-bottom: 30px;
  }
  h4 {
    color: ${({theme}) => theme.colors.secondary};
    margin: 30px auto;
  }
`;
